// ─── Partner Endpoints ────────────────────────────────────────────────────────

export const API_GET_ALL_PARTNERS = '/admin/getAllPartnerList/';
export const API_GET_ALL_PARTNERS_PAGINATION = '/admin/getAllPartnerListPagination/';
export const API_EDIT_PARTNER = '/admin/editPartner/';
export const API_ADD_PARTNER = '/admin/addPartner/';
export const API_GET_PARTNER = '/admin/getPartnerById/';
export const API_GET_PARTNERS_INVOICES = '/admin/partner/partnerInvoicesById/';
export const API_REGENERATE_INVOICE = '/admin/partner/regenerateInvoice/';
export const API_DELETE_PARTNER = '/admin/deletePartner/';
